import { DashboardWidget } from '../../Dashboard/DashboardWidget/DashboardWidget';

const def: DashboardWidgetDefinition = {
    id: 'client_directed',
    title: 'Client Directed Portfolios',
    type: 'portfolio',
    queryMeta: {
        dataVariant: 'report',
    },
    filters: [
        {
            id: 'isClientDirected',
            value: true,
        },
    ],
    columnIds: [
        'tradeDate',
        'aC',
        'portfolioGuid',
        'householdName',
        'nav',
        'cash',
        'isClientDirected',
        'isSuspended',
        'suspendedAt',
        'isMirrorLinked',
        'referencePortfolio',
        'accountType',
        'brokerId',
    ],
};

export const ClientDirected = () => <DashboardWidget widgetDefinition={def} />;
